export const SET_WORKSPACE = "SET_WORKSPACE";

export const setWorkspace = (workspace) => {
  localStorage.setItem("workspace", workspace);
  return { type: SET_WORKSPACE, payload: workspace };
};
